module.exports = __webpack_public_path__ + "img/player-form-unkown-icon.07f829db.svg";